export default __webpack_public_path__ + "e625f3f7b5d15a3541e29cf9c144b330.png";